import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import Load from "../components/landingpage/load";
import '../styles/header.css';

import { useParams } from 'react-router-dom';
import Header from "./header";
import Footer from "./footer";
import Breadcrumbs from "./breadcrumbs";
import Whatsapp from '../components/landingpage/whatsapp';
import { FaTshirt } from "react-icons/fa";
import { MdFastfood } from "react-icons/md";
import { MdElectricBolt } from "react-icons/md";
import { FaBuilding } from "react-icons/fa6";
import { MdOutlineComputer } from "react-icons/md";
import { MdLocalPharmacy } from "react-icons/md";
import { FaIndustry } from "react-icons/fa6";
import { FaHospitalAlt } from "react-icons/fa";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import Error404 from "../pages/Error404";

function Subcat() {

  const { slug } = useParams();
  const navigate = useNavigate();
  const [allcats, setAllcats] = useState([]);
  const [load, setLoad] = useState([]);
  const [title, setTitle] = useState([]);
  const [visibleChildCount, setVisibleChildCount] = useState(12);  // Initially show 12 child categories
  const [hasFetched, setHasFetched] = useState(false);

  const [showSidebar, setShowSidebar] = useState(false);
  const toggleSidebar = () => setShowSidebar(!showSidebar);


  const SideBarCategories = [
    {
      id: "a3d2fa1b-1c5b-4f3e-bf75-193f698a380d",
      name: "Apparel & Garments",
      icon: "FaTshirt",
      link: "/sub/apparel-garments"
    },
    {
      id: "b2cfe557-1fdb-4e16-8f85-b9cd6cc4b0f3",
      name: "Food & Beverages",
      icon: "MdFastfood",
      link: "/sub/food-beverages"
    },
    {
      id: "d51969f3-5638-47f9-a0a9-b1fd8e17a7b2",
      name: "Electronics & Electrical",
      icon: "MdElectricBolt",
      link: "/sub/electronics-electrical"
    },
    {
      id: "c2ae7730-0b4f-42a3-bf60-b27d0152903b",
      name: "Building Construction",
      icon: "FaBuilding",
      link: "/sub/building-construction"
    },
    {
      id: "fe879c9a-02a7-4bc0-9c78-2bfbcc4b5e74",
      name: "Computer & IT Solutions",
      icon: "MdOutlineComputer",
      link: "/sub/computer-it-solutions"
    },
    {
      id: "f703e174-0fe7-4e52-9f98-3e7e436bba34",
      name: "Drugs & Pharmaceuticals",
      icon: "MdLocalPharmacy",
      link: "/sub/drugs-pharmaceuticals"
    },
    {
      id: "e57d2e93-b178-45f4-bbb2-e69ab5151c34",
      name: "Industrial Plants & Machinery",
      icon: "FaIndustry",
      link: "/sub/industrial-plants-machinery"
    },
    {
      id: "bb89a3c8-61b9-4cd0-b5b7-0dbce491dd25",
      name: "Hospital & Diagnostics",
      icon: "FaHospitalAlt",
      link: "/sub/hospital-diagnostics"
    }
  ];

  const iconMap = {
    FaTshirt: <FaTshirt color='#d1d5db' />,
    MdFastfood: <MdFastfood color='#d1d5db' />,
    MdElectricBolt: <MdElectricBolt color='#d1d5db' />,
    FaBuilding: <FaBuilding color='#d1d5db' />,
    MdOutlineComputer: <MdOutlineComputer color='#d1d5db' />,
    MdLocalPharmacy: <MdLocalPharmacy color='#d1d5db' />,
    FaIndustry: <FaIndustry color='#d1d5db' />,
    FaHospitalAlt: <FaHospitalAlt color='#d1d5db' />
  };

  useEffect(() => {
    const a = localStorage.getItem("title");
    getServercats();
  }, []);

  const getServercats = async () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const id = params.get("id");

    setTitle(params.get("s"));

    const data = new FormData();
    data.append("slug", slug);

    axios({
      method: "post",
      url: "/mainsite/all_sub_by_name.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setAllcats(s.data);
        setHasFetched(true);
        console.log("dat_sub_cat", s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };

  const toggleView = () => {
    if (visibleChildCount === 12) {
      setVisibleChildCount(allcats[0].child.length);  // Show all child categories
    } else {
      setVisibleChildCount(12);  // Show only 12 child categories
    }
  };

  return (
    <>
      <Header />
      <main className="main">
        <Breadcrumbs categoryId='' slug={slug} title={title} setTitle={setTitle} />
        <div className="section-box shop-template">
          <div className="container">
            <div className="row">
            <div className="col-lg-12 mb-3">
  {allcats[0]?.categoryStatus !== 'enable' ? (
    <div className="p-3 rounded border" style={{ boxShadow: '0px 0px 17px 6px #ccc', borderRadius: '16px',backgroundColor: '#fff8f8' }}>
      <h5 className="text-danger mb-2">
        ❌ We are not currently dealing in this category.
      </h5>
      <p className="mb-2">
        For your quotation, please submit an inquiry against this category using the link below:
      </p>
      <a href="/inquiry" className="btn btn-outline-danger">
        Submit Inquiry
      </a>
    </div>
  ) : (
    <div className="p-3 rounded border" style={{ boxShadow: '0px 0px 17px 6px #ccc', borderRadius: '16px',backgroundColor: '#f8fff8' }}>
      <h5 className="text-success mb-2">
        ✅ We are currently accepting quotations in this category.
      </h5>
    </div>
  )}
</div>

            
<div className={`col-lg-3 mb-3 ${showSidebar ? '' : 'd-none d-lg-block'}`}>
  <div className="mb-0 order-last order-sm-first" style={{ boxShadow: '0px 0px 17px 6px #ccc', borderRadius: '16px', backgroundColor: '#fff', height: 'max-content', padding: '20px 8px 8px 8px' }}>
    {/* Sidebar title */}


    <div className="d-lg-none w-100 d-flex justify-content-between align-items-center px-2">
    <h1 className="color-gray-900 main-heading-style w-100 py-2 fs-6 font-bold m-0">Product Categories</h1>
    <button
      className="btn btn-sm btn-danger"
      onClick={toggleSidebar}
    >
      X
    </button>
  </div>

    {/* Sidebar categories */}
    <div className="sidebar-content mt-3" style={{ backgroundColor: '#fff', cursor: 'pointer', borderRadius: '16px', marginBottom: '16px' }}>
      {SideBarCategories.map(category => (
        <span key={category.id} className='d-flex ml-2 mt-2' style={{ lineHeight: '36px', color: '#555' }}>
          {iconMap[category.icon] && <span className='mr-3'>{iconMap[category.icon]}</span>}
          <span onClick={() => { localStorage.setItem("title", category.name); window.location.assign(category.link); }}
                className='sidebar-font-size' 
                style={{ fontSize: '14px', lineHeight: '32px', color: '#020617' }}>
            {category.name}
          </span>
        </span>
      ))}
      <Link to='/main'>
        <span className='d-inline-block ml-4 mt-3 mb-0 fw-normal' style={{ color: '#FD9636', fontSize: '16px' }}>
          View All Categories
        </span>
      </Link>
    </div>
  </div>
</div>


              <div className="col-lg-9 mb-3">
                <div className="p-20 mb-3 order-last order-lg-last" style={{ boxShadow: '0px 0px 17px 6px #ccc', borderRadius: '16px', backgroundColor: '#fff', height: "100%" }}>
                  {title != null && title && (
                    <div className="d-flex justify-content-between align-items-center pl-2 mt-2 mb-5" style={{ borderRadius: '16px' }}>
  <h1 className="color-gray-900 main-heading-style py-3 fs-6 font-bold m-0 text-center w-100 d-lg-block d-none">{title}</h1>

  {/* Mobile view title and toggle */}
  <div className="d-lg-none w-100 d-flex justify-content-between align-items-center px-2">
    <h1 className="color-gray-900 main-heading-style py-2 fs-6 w-100 font-bold m-0">{title}</h1>
    <button
      className="btn btn-sm btn-primary"
      onClick={toggleSidebar}
    >
      ☰
    </button>
  </div>
</div>

                  )}

                  {
                    allcats.length > 1 ? "" : allcats.length == 1 ? allcats[0].child.length > 0 ? "" : hasFetched && <Error404 message="No product found" /> : ""
                  }

                  {
                    allcats.length > 1
                      ? allcats.map((v, i) => (
                        <div key={i} className="col-xl-3 col-lg-3 col-6">
                          <div className="card-grid-style-3">
                            <div className="card-grid-inner">
                              <div className="image-box">
                                <a href={"/sub/" + v.bread_crumbs}>
                                  <img style={{ height: "200px", width: "200px" }} className="text-center item-homepage-card-img" src={v.img} alt={v.title} />
                                </a>
                              </div>
                              <div className="info-right text-center">
                                <a className="color-brand-3" style={{ textAlign: 'center', fontWeight: 400, fontSize: '1px' }} href={"/sub/" + v.bread_crumbs}>{v.title}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                      : <div className="row row-sm">
                      {allcats.length == 1
                        ? allcats[0].child.slice(0, visibleChildCount).map((v, i) => (
                            <div key={i} className="col-xl-3 col-lg-3 col-md-6 col-6">
                              {allcats[0].code != 'product' ? (
                                <div className="card-grid-style-3 h-100">
                                  <div className="card-grid-inner d-flex flex-column h-100">
                                    <div className="image-box text-center">
                                      <a href={"/sub/" + v.bread_crumbs}>
                                        <img
                                          style={{ height: "200px", width: "200px" }}
                                          className="item-homepage-card-img"
                                          src={v.img}
                                          alt={v.title}
                                        />
                                      </a>
                                    </div>
                                    <div className="info-right text-center mt-2">
                                      <a className="color-brand-3 card_text_color" href={"/sub/" + v.bread_crumbs}>
                                        {v.title}
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="card-grid-style-3 h-100">
                                  <div className="card-grid-inner d-flex flex-column text-center h-100">
                                    <a href={"/product?id=" + v.id + "&s=" + v.name}>
                                      <div className="image-box">
                                        <img
                                          style={{ height: "200px", width: "200px" }}
                                          className="text-center item-homepage-card-img"
                                          src={v.img}
                                          alt={v.name}
                                        />
                                      </div>
                                    </a>
                                    <div className="info-right text-center mt-2">
                                      <a className="card_text_color" href={"/product?id=" + v.id + "&s=" + v.name}>
                                        {v.name}
                                      </a>
                                    </div>
                                    <div className="mt-auto">
                                      <a href={"/product?id=" + v.id + "&s=" + v.name}>
                                        <p
                                          className="my-2"
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            color: v.price != 0 ? "#036770" : "red",
                                          }}
                                        >
                                          {v.price != 0
                                            ? new Intl.NumberFormat("en-PK", {
                                                style: "currency",
                                                currency: "PKR",
                                                minimumFractionDigits: 2,
                                              }).format(v.price)
                                            : window.zero_price}
                                        </p>
                                        <button
                                          className="btn btn-sm w-100"
                                          style={{
                                            maxHeight: "50px",
                                            borderRadius: "5px",
                                            backgroundColor: "#45ACB3",
                                            color: "white",
                                            border: "none",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                            fontSize: "13px",
                                          }}
                                        >
                                          Get Quote
                                        </button>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          ))
                        : <Error404 message="Please Wait,..." />}
                    </div>                    
                  }

                  {/* View More / View Less Button */}
                  {allcats[0] && allcats[0].child.length > 12 && (
                    <button onClick={toggleView} className="custom-theme-button">
                      {visibleChildCount === 12 ? 'View More' : 'View Less'}
                    </button>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer title={title} />
    </>
  );
}

export default Subcat;
